<template>
  <AuthLayout>
    <LoginFormEmpresa />
  </AuthLayout>
</template>

<script setup>
import AuthLayout from "@/layouts/AuthLayout.vue";
import LoginFormEmpresa from "@/components/LoginFormEmpresa.vue";
</script>
